import HTTP_BACK_OFFICE from '@/http';
import auth from '@/utils/auth';
import store from '@/store';
import downloadjs from 'downloadjs';
import UPDATE_AUTHENTIFICATION from './types';

export default {

  login(context, params) {
    return HTTP_BACK_OFFICE.post('/driver/deskrh/login', params)
      .then((data) => {
        if (data.status === 200) {
          HTTP_BACK_OFFICE.defaults.headers.common.Authorization = `Bearer ${data.headers['set-authorization']}`;
          HTTP_BACK_OFFICE.defaults.headers.common['Refresh-Token'] = data.headers['set-refresh-token'];
          const session = {
            userLogin: data.data.data.login,
            token: data.headers['set-authorization'],
            refreshToken: data.headers['set-refresh-token'],
          };
          auth.login(session);
          context.commit(UPDATE_AUTHENTIFICATION, true);
        }
      })
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Erreur au login<br>Erreur: ${error}` });
      });
  },

  getDrivers(context, params) {
    let url = `/driver/all?from=${params.from}&count=${params.count}`;
    if (params.clientName) {
      url += `&clientName=${params.clientName}`;
    }
    if (params.driverName) {
      url += `&driverName=${params.driverName}`;
    }
    return HTTP_BACK_OFFICE.get(url)
      .then(result => result.data.data)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Erreur lors de la récupération des drivers<br>Erreur: ${error}` });
      });
  },

  getDriver(context, id) {
    return HTTP_BACK_OFFICE.get(`/driver/${id}`)
      .then(result => result.data.data.result)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu lors de la récupération des informaions de ce driver<br>Erreur: ${error}` });
      });
  },

  getLogs(context, params) {
    return HTTP_BACK_OFFICE.get(`/driver/${params.id}/logs/all?from=${params.from}&count=${params.count}`)
      .then(result => result.data.data)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu à la récupération des log<br>Erreur: ${error}` });
      });
  },

  viewLog(context, params) {
    return HTTP_BACK_OFFICE.get(`/driver/${params.driverId}/logs/${params.logId}/view`)
      .then(data => data)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu à la récupération du log<br>Erreur: ${error}` });
      });
  },

  driverNotInError(context, id) {
    return HTTP_BACK_OFFICE.post(`/driver/${id}/errorState/reset`)
      .then((data) => {
        store.dispatch('app/openSnackbar', { message: 'L\'état du driver a bien été mis à jour' });
        return data;
      })
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu, nous n'avons pas pu mettre à jour le statut du driver<br>Erreur: ${error}` });
      });
  },

  downloadLog(context, params) {
    return HTTP_BACK_OFFICE.get(`/driver/${params.driverId}/logs/${params.logId}/download`, {
      responseType: 'arraybuffer',
      headers: { Accept: 'application/octet-stream, */*' },
    })
      .then((data) => {
        downloadjs(data.data, `log-du-${params.logTimeStamp}.zip`);
      })
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu au téléchargement du log<br>Erreur: ${error}` });
      });
  },

  routeVIP(context, id) {
    return HTTP_BACK_OFFICE.post(`/driver/${id}/errorState/anita`)
      .then(data => console.log(data))
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `gfgfgfgf<br>Erreur: ${error}` });
      });
  },

  setDeskRhHeaders() {
    HTTP_BACK_OFFICE.defaults.headers.common.Authorization = `Bearer ${auth.getSessionToken()}`;
    HTTP_BACK_OFFICE.defaults.headers.common['Refresh-Token'] = auth.getSessionRefreshToken();
  },
};



// WEBPACK FOOTER //
// ./src/store/drivers/actions.js